import { render } from "./DashboardHeaderSlot.vue?vue&type=template&id=1b1ae8e4"
import script from "./DashboardHeaderSlot.vue?vue&type=script&lang=js"
export * from "./DashboardHeaderSlot.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__